import { v4 as uuidv4 } from 'uuid';
import { normalizeHexColor } from './richText.js';
import { normalizeStoredImageItem, revokeLocalImageUrl } from './localImage.js';
import { LOCAL_ASSET } from './localAssets.js';
import { getMediaItemUrl } from './qiniuMedia.js';

export const IMAGE_FEATURE_CARD_TYPE = 'image-feature-card';
export const IMAGE_FEATURE_CARD_DEFAULT_RADIUS = 12;
export const IMAGE_FEATURE_CARD_COVER_ASPECT = '16 / 9';

const DEFAULT_TITLE = '跨境独立站选品实操';
const DEFAULT_DESCRIPTION = '从市场筛选、利润测算到商品上架，完整演示独立站项目的选品方法与首单测试流程。';
const DEFAULT_TITLE_COLOR = '#333333';
const DEFAULT_DESC_COLOR = '#999999';

function createDefaultImage() {
	return {
		id: `image-feature-card-${uuidv4()}`,
		filename: 'img-feature-card.png',
		previewUrl: LOCAL_ASSET.imgFeatureCard,
		url: '',
		local: false,
	};
}

export function getImageFeatureCardDefaults() {
	return normalizeImageFeatureCardData({});
}

export function isImageFeatureCardBlock(blockType) {
	return blockType === IMAGE_FEATURE_CARD_TYPE;
}

export function getImageFeatureCardImageUrl(image) {
	if (!image) return '';
	return getMediaItemUrl(image);
}

function normalizeCardImage(image, fallback) {
	if (!image?.previewUrl && !image?.url) {
		return fallback ? { ...fallback } : null;
	}
	return normalizeStoredImageItem(image, fallback);
}

export function normalizeImageFeatureCardData(data = {}) {
	const fallbackImage = createDefaultImage();
	const radius = Number(data.borderRadius);

	return {
		title: data.title ?? DEFAULT_TITLE,
		description: data.description ?? DEFAULT_DESCRIPTION,
		titleColor: normalizeHexColor(data.titleColor || DEFAULT_TITLE_COLOR),
		descColor: normalizeHexColor(data.descColor || data.descriptionColor || DEFAULT_DESC_COLOR),
		borderRadius: Number.isFinite(radius)
			? Math.max(0, radius)
			: IMAGE_FEATURE_CARD_DEFAULT_RADIUS,
		image: normalizeCardImage(data.image, fallbackImage),
		jumpLink: data.jumpLink?.type ? { ...data.jumpLink } : null,
	};
}

export function getImageFeatureCardBlockStyle(data = {}, { h5 = false } = {}) {
	const normalized = normalizeImageFeatureCardData(data);
	const pxRatio = h5 ? 50 : 1;
	const radius = normalized.borderRadius;

	return {
		coverAspectRatio: IMAGE_FEATURE_CARD_COVER_ASPECT,
		borderRadius: h5 ? `${radius / pxRatio}rem` : `${radius}px`,
	};
}

export function replaceImageFeatureCardImage(currentImage, file, createLocalImageItem) {
	if (currentImage?.local) {
		revokeLocalImageUrl(currentImage.previewUrl);
	}
	return createLocalImageItem(file);
}
